import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=16884021&"
import script from "./Deposit.vue?vue&type=script&lang=ts&"
export * from "./Deposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports